import React from "react";
import "./Widgets.css";
import SearchIcon from "@material-ui/icons/Search";
import {
  TwitterTimelineEmbed,
  TwitterShareButton,
  TwitterTweetEmbed
} from "react-twitter-embed";
function Widgets() {
  return (
    <div className="widgets">
      <div className="widgets__input">
        <input placeholder="Search Twitter" type="text" />
        <SearchIcon className="widgets__searchIcon" />
      </div>
      <div className="widgets__widgetContainer">
        <h2>What's happening?</h2>
        {/* <a
          class="twitter-timeline"
          data-lang="en"
          data-theme="dark"
          href="https://twitter.com/fashion?ref_src=twsrc%5Etfw"
        >
          Tweets by fashion
        </a>
        <script
          async
          src="https://platform.twitter.com/widgets.js"
          charset="utf-8"
        ></script> */}
        <a
          class="twitter-timeline"
          href="https://twitter.com/narendramodi?ref_src=twsrc%5Etfw"
        >
          Tweets by narendramodi
        </a>{" "}
        <script
          async
          src="https://platform.twitter.com/widgets.js"
          charset="utf-8"
        ></script>
        <TwitterTweetEmbed tweetId={"858551177860055040"} />
        <TwitterTimelineEmbed
          sourceType="profile"
          screenName="cleverqazi"
          options={{ height: 400 }}
        />
        <TwitterShareButton
          url={"https://facebook.com/cleverprogrammer"}
          options={{ text: "#reactjs is awesome", via: "cleverqazi" }}
        />
      </div>
    </div>
  );
}

export default Widgets;
